export const base = {
    "recent_test": "recent test",
    "parts": "list lessons",
    "list_result": "list result",
    "result": "result",
    "alert_submit": "Submit",
    "mid_test": "mid-term test",
    "final_test": "final test",
    "survey_type": "survey",
    "vote_type": "vote",
    "learn_everywhere": "Learning everytime and everywhere",
    "confirm": "Confirm",
    "question": "Question",
    "continue_practice": "continue to practice",
    "retest": "retest",
    "practice_lesson": "practice lesson",
    "retake_test": "retest",
    "test": "test",
    "practice": "practice",
    "exam": "exam",
    "submit": "Submit",
    "continue": "next",
    "comeback": "back",
    "yes": "Yes",
    "no": "No",
    "your_opinion": "Your opinion",
    "back_lesson": "Back",
    "correct_answer": "Correct answer",
    "user_name": "Student's name",
    "phone_number": "Phone number",
};
